module.exports = __webpack_public_path__ + "img/UNKNOWN.ca3b280b.png";